import React, { useState } from 'react';
import { Building } from 'lucide-react';
import DepartamentosPage from './DepartamentosPage';
import ProveedoresPage from './ProveedoresPage';
import PersonalPage from './PersonalPage';
import InventarioPage from './InventarioPage';
import UsuariosPage from './UsuariosPage';

const TABS = [
    { id: 'departamentos', label: 'Departamentos', component: DepartamentosPage },
    { id: 'proveedores', label: 'Proveedores', component: ProveedoresPage },
    { id: 'personal', label: 'Personal', component: PersonalPage },
    { id: 'inventario', label: 'Inventario', component: InventarioPage },
    { id: 'usuarios', label: 'Usuarios', component: UsuariosPage }
];

const AdministracionPage = () => {
    const [activeTab, setActiveTab] = useState('departamentos');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-blue-500/20">
                        <Building className="text-blue-400" size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Administración</h1>
                        <p className="text-slate-400">Gestión de departamentos, proveedores, personal, inventario y usuarios</p>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700">
                <div className="flex gap-2">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                px-6 py-3 font-medium transition-all relative
                ${activeTab === tab.id
                                    ? 'text-blue-400 border-b-2 border-blue-400'
                                    : 'text-slate-400 hover:text-white'
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default AdministracionPage;
